import type { app, firestore } from "firebase";
import { activeEventsClient } from "../sdk";
import { ensureClientInitialized } from './firebase';
import { ActiveEvent, parseActiveEventFromDocument } from './types/activeEvents';

const FIREBASE_APP_NAME = "Global";

let unsubscribeFunctions: (() => void)[] = [];

const fetchFirebaseConfig = async () => {
    const firebaseConfig = await activeEventsClient.activeEventService.getActiveEventsFirebaseConfig({});

    return {
        authToken: firebaseConfig.authToken,
        options: firebaseConfig.config,
        proxyDomain: firebaseConfig.config?.proxyDomain || "",
    }
};

export const setActiveEventsListener = async (listener: (docs: ActiveEvent[]) => void) => {
    const firebaseClient = await ensureClientInitialized(FIREBASE_APP_NAME, false, fetchFirebaseConfig);
    if (!firebaseClient) {
      return;
    }
  
    const currentUser = firebaseClient.auth().currentUser;
    if (!currentUser) {
      return;
    }
  
    const activeEventFirestoreClient = new ActiveEventFirestoreClient(firebaseClient);
    unsubscribeFunctions.push(activeEventFirestoreClient.getActiveEventsCollection(currentUser.uid).onSnapshot(
      (q: firestore.QuerySnapshot) => {
        const events = q.docs.map(d => parseActiveEventFromDocument(d));
        listener(events.filter((ev):ev is ActiveEvent => ev != null));
      }
    ));
  };
  
export const clearActiveEventsListeners = () => {
  unsubscribeFunctions.forEach(unsubscribe => unsubscribe());
  unsubscribeFunctions = [];
}

class ActiveEventFirestoreClient {
  private client : app.App;

  constructor(client: app.App) {
    this.client = client;
  }

  getUserDocument = (userId: string) =>
    this.client
      .firestore()
      .collection("users")
      .doc(`${userId}`);
    
  getActiveEventsCollection = (userId: string) =>
    this.getUserDocument(userId).collection("activeEvents");
}
